import brAxios from 'Api/Interceptors';

export const SiteBasicSettingEc = {
  getSetting: (type: number) => brAxios.get(`/ec-site/settings?type=${type}`),
  updateSetting: (formData: FormData) =>
    brAxios.post('/ec-site/settings/basic-settings/update', formData),
  updateDocument: (data: any) => brAxios.post('/ec-site/settings/terms-service/update', data),
};
